/*
 * sessionStorage key layout for the tldraw board TldrawCanvasPanel keeps fresh
 * every turn. One place owns the format so readers (canvasApi's persist
 * checkpoint) and the clears below cannot drift apart.
 *
 *   canvas_state_{sessionId}-{slideIndex}             — limited mode, single board
 *   canvas_state_{sessionId}-{slideIndex}-page-{n}    — paged mode
 */
export const notepadCanvasStatePrefix = (
  sessionId: string | number,
  slideIndex: string | number,
): string => `canvas_state_${sessionId}-${slideIndex}`;

export const notepadCanvasStateKey = (
  sessionId: string | number,
  slideIndex: string | number,
  pageIndex?: number | null,
): string => {
  const prefix = notepadCanvasStatePrefix(sessionId, slideIndex);
  return pageIndex === null || pageIndex === undefined || pageIndex < 0
    ? prefix
    : `${prefix}-page-${pageIndex}`;
};

const storageKeys = (storage: Storage): string[] => {
  const keys: string[] = [];
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (key) keys.push(key);
  }
  return keys;
};

export const clearSessionNotepadPersistence = (
  sessionId: string | number | null | undefined,
  storage: Storage = sessionStorage,
): void => {
  if (sessionId === null || sessionId === undefined || sessionId === "") {
    return;
  }

  const canvasStatePrefix = `canvas_state_${sessionId}-`;
  const canvasPagesPrefix = `canvas_pages_${sessionId}-`;
  storageKeys(storage).forEach((key) => {
    if (
      key.startsWith(canvasStatePrefix) ||
      key.startsWith(canvasPagesPrefix)
    ) {
      storage.removeItem(key);
    }
  });
};

export const clearSlideNotepadPersistence = (
  sessionId: string | number | null | undefined,
  slideIndex: string | number | null | undefined,
  storage: Storage = sessionStorage,
): void => {
  if (
    sessionId === null ||
    sessionId === undefined ||
    sessionId === "" ||
    slideIndex === null ||
    slideIndex === undefined ||
    slideIndex === ""
  ) {
    return;
  }

  const slideKey = `${sessionId}-${slideIndex}`;
  const statePrefix = notepadCanvasStatePrefix(sessionId, slideIndex);
  storageKeys(storage).forEach((key) => {
    if (key.startsWith(statePrefix)) {
      storage.removeItem(key);
    }
  });
  storage.removeItem(`canvas_pages_${slideKey}`);
};
